import parse from 'html-react-parser';
import { NumericFormat } from 'react-number-format';
import AlertBox from './AlertBox';
import { NumberformatElementType } from '../helpers/types';

type Props = {
    value: string | number;
    onChange: (value: string | number) => void;
    error: string | null;
    errorType: string;
    prefix?: string;
    suffix?: string;
};

const NumberInput = (props: NumberformatElementType & Props) => {
    const { value, onChange, error, errorType, placeholder, label, prefix, suffix, description } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const valueWithoutSpaces = e.target.value.replace(/\s+/g, ''); // Removes all spaces
        onChange(valueWithoutSpaces);
    };

    return (
        <>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className="input-group">
                {prefix && <span className="input-group-text">{prefix}</span>}
                <NumericFormat value={value != 0 ? value : ''} onChange={handleChange} thousandSeparator=" " className={`form-control ${error && value ? 'is-invalid' : value != 0 ? 'is-valid' : ''}`} placeholder={placeholder} />
                {suffix && <span className="input-group-text">{suffix}</span>}
            </div>

            {error && (errorType === 'custom' ? <AlertBox classes="mt-3">{error}</AlertBox> : <div className="invalid-feedback">{parse(error)}</div>)}
        </>
    );
};

export default NumberInput;
